export const START_KEY = '__start__';
export const END_KEY = '__end__';
export const WATERFALL_VALUE = '__waterfall_value__';
